<div class="tw-flex tw-flex-col tw-items-center">
  <svg [attr.width]="size" [attr.height]="size/2 + 30" [attr.viewBox]="'0 0 ' + size + ' ' + (size/2 + 30)">
    <!-- Fondo del gauge -->
    <path
      [attr.d]="'M ' + (center - radius) + ' ' + center + ' A ' + radius + ' ' + radius + ' 0 0 1 ' + (center + radius) + ' ' + center"
      [attr.stroke-width]="thickness"
      [attr.stroke]="backgroundColor"
      fill="none"
    />
    
    <!-- Secciones generadas dinámicamente desde rangeSections -->
    <path
      *ngFor="let section of rangeSections"
      [attr.d]="arcPath(section.min, section.max)"
      [attr.stroke-width]="thickness"
      [attr.stroke]="section.color"
      fill="none"
      stroke-linecap="butt"
    />
    
    <!-- Valor central -->
    <text
      [attr.x]="center"
      [attr.y]="center - 5"
      text-anchor="middle"
      class="tw-text-3xl tw-font-bold"
      >
      {{getDisplayValue()}}
    </text>
    
    <!-- Flecha -->
    <g *ngIf="value !== null && value !== undefined">
      <g [attr.transform]="'translate(' + arrowX + ' ' + arrowY + ') rotate(' + arrowRotation + ')'"
         class="tw-transition-all tw-duration-300 tw-ease-in-out">
        <path 
          d="M0 0l6 6 6-6h-4v-20h-4v20h-4z"
          class="tw-fill-black"
          transform="translate(-6, -10)"
        />
      </g>
    </g>
  </svg>
  
  <!-- Etiqueta -->
  <span *ngIf="label" class="tw-mt-2 tw-text-sm tw-text-gray-600">{{label}}</span>
</div> 

